import { type FunctionComponent, type ReactNode, useState } from 'react'
import styled, { css } from 'styled-components'
import Close from '../../assets/icons/close.svg'

export enum AlertLevel {
  Error = 'error',
  Info = 'info',
  Neutral = 'neutral',
  Warning = 'warning',
}

const Wrapper = styled.div<{ $mapBanner?: boolean; $legacyMap?: boolean }>`
  padding: 1rem;
  width: 100%;
  overflow: hidden;
  overflow-wrap: anywhere;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  line-height: 1.4;
  color: var(--dark);

  p {
    margin: 0;
  }

  button.close {
    background-color: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: flex-start;
    margin-top: 0;
    padding: 0;
  }

  a {
    color: inherit;
  }

  svg {
    width: 1.25rem;
    height: auto;
    margin-left: 1rem;
  }

  &.error {
    background-color: var(--red);
    color: var(--light);
    svg {
      fill: var(--light);
    }
  }
  &.info {
    background-color: var(--blue);
    color: var(--light);
    svg {
      fill: var(--light);
    }
  }
  &.neutral {
    background-color: var(--greyLight);
    svg {
      fill: var(--dark);
    }
  }
  &.warning {
    background-color: var(--yellow);
    svg {
      fill: var(--dark);
    }
  }
  ${({ $mapBanner, $legacyMap }) =>
    $mapBanner &&
    ($legacyMap
      ? css`
          position: absolute;
          left: 100%;
          bottom: 1rem;
          pointer-events: all;
          width: 500px;
          z-index: 999;

          p {
            color: var(--dark);
            font-size: 1rem;
          }
        `
      : css`
          position: absolute;
          left: 168px;
          bottom: 1rem;
          pointer-events: all;
          width: 500px;
          z-index: 999;

          p {
            color: var(--dark);
            font-size: 1rem;
          }
        `)}
`

const ChildrenWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const Alert: FunctionComponent<{
  children: ReactNode
  level: AlertLevel
  dismissible?: boolean
  mapBanner?: boolean
  legacyMap?: boolean
}> = ({ children, level, dismissible, mapBanner, legacyMap, ...otherProps }) => {
  const [showAlert, setShowAlert] = useState(true)

  return showAlert ? (
    <Wrapper className={level} $mapBanner={mapBanner} $legacyMap={legacyMap} {...otherProps}>
      <ChildrenWrapper>{children}</ChildrenWrapper>
      {dismissible && (
        <button type="button" className="close">
          <Close onClick={() => setShowAlert(false)} />
        </button>
      )}
    </Wrapper>
  ) : null
}

export default Alert
